import {Select, SelectItem} from "@heroui/react";
import {useQuery} from '@tanstack/react-query';
import repositories from '../../repositories.jsx';
import clsx from "clsx";

export default function Languages({data = [],
									  onChanged,
									  form, valueKey = 'voice_id',
									  placeholder="Choose...",classNames = {}, ...props}) {
	const languages = useQuery({
		queryKey: ['languages'],
		queryFn: repositories.project.languages
	})

	const mergedClassNames = {
		trigger: clsx("min-h-10 bg-white shadow-none border-slate-300", classNames.trigger),
		base: classNames.base,
		label: classNames.label,
		mainWrapper: classNames.mainWrapper,
		innerWrapper: classNames.innerWrapper,
		selectorIcon: classNames.selectorIcon,
		value: classNames.value,
		listboxWrapper: classNames.listboxWrapper,
		listbox: classNames.listbox,
		popoverContent: classNames.popoverContent,
		helperWrapper: classNames.helperWrapper,
		description: classNames.description,
		errorMessage: classNames.errorMessage
	};


	return (
		<>
			<Select
				isLoading={languages.isPending}
				items={languages.data || []}
				aria-label="Language select"
				aria-labelledby="Language select"
				placeholder={placeholder}
				selectionMode="single"
				variant="bordered"
				classNames={mergedClassNames}
				selectedKeys={[form?.values?.language]}
				onSelectionChange={(keys) => {
					if (typeof onChanged === 'function') {
						onChanged(keys?.currentKey)
					}
				}}
			>
				{(item) => item?.code !== 'auto' && <SelectItem
					className="min-h-12"
					key={item?.code}
					textValue={item?.language}
					children={item?.language}
				/>}
			</Select>
		</>
	);
}
